import { render, staticRenderFns } from "./ProjectChoiceSettings.vue?vue&type=template&id=75c36e0e&scoped=true&"
import script from "./ProjectChoiceSettings.vue?vue&type=script&lang=js&"
export * from "./ProjectChoiceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c36e0e",
  null
  
)

export default component.exports